import loading from '../../assets/loading.gif';

const Loader = ({ text }) => {
    return (
        <div className="loading-pnl">
            <div className="loading-box">
                <img src={loading} className="loading-spinner" alt="spinner" />
                <div className="loading-text">{text}</div>
            </div>
        </div>
    );
};

export default Loader;